import React, { useState, useCallback, useEffect } from 'react';
import { Modal, Form, Row, Col, Input, InputNumber, message, Checkbox, Tabs, Button, Divider } from 'antd';
import { DeleteRowOutlined, PlusOutlined, MinusCircleOutlined } from '@ant-design/icons';
import CONSTANT from '../../../config/constant';
import { axiosInstance } from '../../../config/api';
const { TextArea } = Input;
const ModalActionService = (props) => {
    const [form] = Form.useForm();
    const [confirmLoading, setConfirmLoading] = useState(false);
    const [showFree, setShowFree] = useState(false);
    const handleCancel = useCallback(() => {
        form.resetFields();
        props.cancel();
    }, [form]);
    useEffect(() => {
        props.data?.price_list.forEach(item => {
            item.name_en = item?.translations?.en.name;
            item?.list.forEach(item1 => {
                item1.type_name_en = item1?.translations?.en.type_name;
            });
        });
        form.setFieldsValue({
            name: props.data?.name,
            summary: props.data?.summary,
            name_en: props.data?.translations?.en?.name,
            summary_en: props.data?.translations?.en?.summary,
            price: props.data?.price,
            price_note: props.data?.price_note,
            price_note_en: props.data?.translations?.en?.price_note,
            is_online: props.data?.is_online,
            is_free: props.data?.is_free,
            is_government_insurance: props.data?.is_government_insurance,            
            note_government_insurance: props.data?.note_government_insurance,
            note_government_insurance_en: props.data?.translations?.en?.note_government_insurance,
            is_direct_guarantee_insurance: props.data?.is_direct_guarantee_insurance,
            note_direct_guarantee_insurance: props.data?.note_direct_guarantee_insurance,
            note_direct_guarantee_insurance_en: props.data?.translations?.en?.note_direct_guarantee_insurance,
            list_direct_guarantee_insurance: props.data?.list_direct_guarantee_insurance,
            price_list: props.data?.price_list,
        });
        console.log()
        if (props.data?.is_online) setShowFree(true);
    }, [props.data]);
    const onSubmit = useCallback(async (values) => {
        setConfirmLoading(true);
        values.translations = {
            en: {
                name: values.name_en,
                summary: values.summary_en,
                price_note: values.price_note_en,
                note_government_insurance: values.note_government_insurance_en,
                note_direct_guarantee_insurance: values.note_direct_guarantee_insurance_en
            }
        }
        if(values?.price_list){
            for (let i = 0; i < values?.price_list.length; i++) {
                let item = values.price_list[i];
                item.translations = {
                    en: {
                        name: item?.name_en
                    }
                }
                for (let j = 0; j < values.price_list[i].list.length; j++) {
                    let item = values.price_list[i].list[j];
                    item.translations = {
                        en: {
                            type_name: item?.type_name_en
                        }
                    }
                }
            }
        }
        
        if (props.data) {
            let dataSave = {
                action: 'updService',
                serviceId: props.data._id,
                name: values.name,
                summary: values.summary,
                price: values.price,
                price_note: values.price_note,
                is_online: values.is_online,
                is_free: values.is_free,
                is_active: false,
                is_government_insurance: values.is_government_insurance,
                note_government_insurance: values.note_government_insurance,
                is_direct_guarantee_insurance: values.is_direct_guarantee_insurance,
                note_direct_guarantee_insurance: values.note_direct_guarantee_insurance,
                list_direct_guarantee_insurance: values.list_direct_guarantee_insurance,
                price_list: values.price_list,
                translations: values.translations
            }
            await axiosInstance.patch(`${CONSTANT.API.DOCTOR.DOCTOR}/${props.doctorId}`, dataSave)
                .then(res => {
                    if (res && res.data && res.data.code === 200) {
                        message.success('Sửa thông tin thành công. Nội dung của bạn sẽ được kiểm duyệt trước khi được công bố đến khách truy cập !')
                        form.resetFields();
                        setConfirmLoading(false);
                        props.cancel(res.data.data);
                    }
                    else {
                        setConfirmLoading(false);
                        message.error('Sửa thông tin thất bại! Vui lòng thử lại sau.');
                    }
                }).catch(() => {message.error('Sửa thông tin thất bại! Vui lòng thử lại sau.');setConfirmLoading(false)});
        }
        else {
            let dataSave = {
                action: 'insService',
                name: values.name,
                summary: values.summary,
                price: values.price,
                price_note: values.price_note,
                is_online: values.is_online,
                is_free: values.is_free,
                is_active: false,
                is_government_insurance: values.is_government_insurance,
                note_government_insurance: values.note_government_insurance,
                is_direct_guarantee_insurance: values.is_direct_guarantee_insurance,
                note_direct_guarantee_insurance: values.note_direct_guarantee_insurance,
                list_direct_guarantee_insurance: values.list_direct_guarantee_insurance,
                price_list: values.price_list,
                translations: values.translations
            }
            await axiosInstance.patch(`${CONSTANT.API.DOCTOR.DOCTOR}/${props.doctorId}`, dataSave)
                .then(res => {
                    if (res && res.data.data && res.data.code === 200) {
                        message.success('Thêm thành công. Nội dung của bạn sẽ được kiểm duyệt trước khi được công bố đến khách truy cập !')
                        form.resetFields();
                        props.cancel(res.data.data);
                    }
                    else {
                        message.error('Thêm thất bại! Vui lòng thử lại sau.');
                    }
                    setConfirmLoading(false);
                }).catch(() => setConfirmLoading(false));

        }
        setConfirmLoading(false);
    }, [props]);
    const onFinishFailed = async (values) => {
        message.error('Vui lòng nhập đầy đủ thông tin theo yêu cầu, cảm ơn !', 5);
    }
    return (
        <Modal title={props.data && props.data._id ? "Sửa thông tin " : "Thêm mới"}
            visible={props.visible}
            onOk={form.submit}
            onCancel={handleCancel}
            cancelText="Hủy"
            okText="Lưu thông tin"
            confirmLoading={confirmLoading}
            className="modal-book-facility"
            centered
            cancelButtonProps={{ className: "btn-global bg btn-cancel" }}
            okButtonProps={{ className: "btn-global bg" }}
            width={700}
            maskClosable={false}
        >
            <Form
                name="basic"
                layout="vertical"
                onFinish={onSubmit}
                onFinishFailed={onFinishFailed}
                form={form}

            >
                <Tabs defaultActiveKey="gt" type="card" size="large" className="tabs-info">
                    <Tabs.TabPane forceRender={true} tab="Thông tin " key="qtdt" className="service-specialty" >
                        <Tabs defaultActiveKey="vi" type="card" tabPosition={'left'} size="large">
                            <Tabs.TabPane tab="Tiếng Việt" key="vi" forceRender={true}>
                                <Row gutter={[24]} align="middle">
                                    <Col xs={24} sm={24} md={24}>
                                        <Form.Item
                                            label="Tên công việc"
                                            tooltip="Tên công việc"
                                            name='name'
                                            rules={[
                                                {
                                                    required: true, message: 'Vui lòng nhập Tên công việc',

                                                }, {
                                                    type: 'string', max: 100, message: "Tên công việc tối đa 100 ký tự !"
                                                }
                                            ]}>
                                            <Input placeholder="Nhập tên công việc" />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} sm={24} md={24}>
                                        <Form.Item label="Mô tả" name="summary"
                                            rules={[
                                                {
                                                    required: true, message: 'Vui lòng nhập mô tả !',
                                                },
                                                {
                                                    type: 'string', max: 1000, message: "Mô tả tối đa 1000 ký tự !"
                                                }
                                            ]}>
                                            <TextArea showCount maxLength={1000} style={{ width: '100%' }} rows={3} />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} sm={10} md={10}>
                                        <Form.Item
                                            label="Giá mặc định"
                                            tooltip="Giá này được áp dụng khi không có bảng giá"
                                            name='price'
                                            rules={[
                                                { required: true, message: 'Vui lòng nhập giá mặc định' },
                                                {
                                                    type: 'number', max: 100000000, message: "Giá mặc định tối đa 100.000.000 !"
                                                }
                                            ]}>
                                            <InputNumber placeholder="Nhập mặc định" min={0}
                                                formatter={value => `₫ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                                parser={value => value.replace('₫', '').replace(/\\s?|(,*)/g, '')}
                                                style={{ width: '100%' }} />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} sm={7} md={7}>
                                        <Form.Item
                                            tooltip="Tư vấn trực tuyến"
                                            name='is_online'
                                            valuePropName="checked"
                                        >
                                            <Checkbox style={{ marginTop: 20 }}
                                                onChange={event => { setShowFree(event.target.checked); form.setFieldsValue({ is_free: false }) }}
                                            >Khám trực tuyến</Checkbox>
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} sm={7} md={7}>
                                        <Form.Item
                                            name='is_free'
                                            valuePropName="checked"
                                        >
                                            <Checkbox style={{ marginTop: 20 }} disabled={!showFree}>Khám miễn phí</Checkbox>
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} sm={24} md={24}>
                                        <Form.Item
                                            label="Ghi chú giá"
                                            tooltip="Ghi chú giá (Bao gồm, không bao gồm ...)"
                                            name='price_note'
                                            rules={[
                                                {
                                                    type: 'string', max: 1000, message: "Mô tả tối đa 1000 ký tự !"
                                                }
                                            ]}
                                        >
                                            <TextArea showCount maxLength={1000} style={{ width: '100%' }} rows={3} />
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Tabs.TabPane>
                            <Tabs.TabPane forceRender={true} tab="Tiếng Anh" key="en">
                                <Row gutter={[24]} align="middle">
                                    <Col xs={24} sm={24} md={24}>
                                        <Form.Item
                                            label="Tên công việc"
                                            tooltip="Tên công việc"
                                            name='name_en'
                                            rules={[
                                                {
                                                    required: true, message: 'Vui lòng nhập Tên công việc',

                                                }, {
                                                    type: 'string', max: 100, message: "Tên công việc tối đa 100 ký tự !"
                                                }
                                            ]}>
                                            <Input placeholder="Nhập tên công việc" />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} sm={24} md={24}>
                                        <Form.Item label="Mô tả" name="summary_en"
                                            rules={[
                                                {
                                                    required: true, message: 'Vui lòng nhập mô tả !',
                                                },
                                                {
                                                    type: 'string', max: 1000, message: "Mô tả tối đa 1000 ký tự !"
                                                }
                                            ]}>
                                            <TextArea showCount maxLength={1000} style={{ width: '100%' }} rows={3} />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} sm={10} md={10}>
                                        <Form.Item
                                            label="Giá mặc định"
                                            tooltip="Giá này được áp dụng khi không có bảng giá"
                                            name='price'
                                            rules={[
                                                { required: true, message: 'Vui lòng nhập giá mặc định' },
                                                {
                                                    type: 'number', max: 100000000, message: "Giá mặc định tối đa 100.000.000 !"
                                                }
                                            ]}>
                                            <InputNumber placeholder="Nhập mặc định" min={0}
                                                formatter={value => `₫ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                                parser={value => value.replace('₫', '').replace(/\\s?|(,*)/g, '')}
                                                style={{ width: '100%' }} />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} sm={7} md={7}>
                                        <Form.Item
                                            tooltip="Tư vấn trực tuyến"
                                            name='is_online'
                                            valuePropName="checked"
                                        >
                                            <Checkbox style={{ marginTop: 20 }}
                                                onChange={event => { setShowFree(event.target.checked); form.setFieldsValue({ is_free: false }) }}
                                            >Khám trực tuyến</Checkbox>
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} sm={7} md={7}>
                                        <Form.Item
                                            name='is_free'
                                            valuePropName="checked"
                                        >
                                            <Checkbox style={{ marginTop: 20 }} disabled={!showFree}>Khám miễn phí</Checkbox>
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} sm={24} md={24}>
                                        <Form.Item
                                            label="Ghi chú giá"
                                            tooltip="Ghi chú giá (Bao gồm, không bao gồm ...)"
                                            name='price_note_en'
                                            rules={[
                                                {
                                                    type: 'string', max: 1000, message: "Mô tả tối đa 1000 ký tự !"
                                                }
                                            ]}
                                        >
                                            <TextArea showCount maxLength={1000} style={{ width: '100%' }} rows={3} />
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Tabs.TabPane>
                        </Tabs>
                    </Tabs.TabPane>
                    <Tabs.TabPane forceRender={true} tab="Bảng giá" key="price_list" className="service-specialty" >
                        <Row gutter={[24]} align="middle">
                            <Col xs={24} sm={24} md={24}>
                                <Form.List name="price_list" label="Danh sách bảng giá được áp dụng">
                                    {(fields, { add, remove }) => {
                                        return (
                                            <>
                                                {
                                                    fields.map((field, index) => (
                                                        <Row gutter={24} key={field.key}>
                                                            <Col xs={11} sm={11} md={11}>
                                                                <Form.Item
                                                                    name={[index, 'name']}
                                                                    required tooltip="Tên bảng giá tiếng Việt"
                                                                    rules={[
                                                                        {
                                                                            required: true, message: 'Vui lòng nhập tên bảng giá tiếng Việt!'
                                                                        }, {
                                                                            type: 'string', max: 50, message: "Tên bảng giá tối đa 50 ký tự !"
                                                                        }
                                                                    ]}
                                                                >
                                                                    <Input placeholder="Nhập tên bảng giá tiếng Việt" prefix={<img src='https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/vn.svg' style={{ width: 20, height: 20 }} />} />
                                                                </Form.Item>
                                                            </Col>
                                                            <Col xs={11} sm={11} md={11}>
                                                                <Form.Item
                                                                    name={[index, 'name_en']}
                                                                    required tooltip="Tên bảng giá tiếng Anh"
                                                                    rules={[
                                                                        {
                                                                            required: true, message: 'Vui lòng nhập tên bảng giá tiếng Anh!'
                                                                        }, {
                                                                            type: 'string', max: 50, message: "Tên bảng giá tối đa 50 ký tự !"
                                                                        }
                                                                    ]}
                                                                >
                                                                    <Input placeholder="Nhập tên bảng giá tiếng Anh" prefix={<img src='https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/gb.svg' style={{ width: 20, height: 20 }} />} />
                                                                </Form.Item>
                                                            </Col>
                                                            <Col xs={2} sm={2} md={2}>
                                                                <Button
                                                                    type="link"
                                                                    danger
                                                                    style={{ width: '100%' }}
                                                                    onClick={() => remove(field.name)}
                                                                    title='Xóa bảng giá này'
                                                                    icon={<DeleteRowOutlined />}
                                                                >
                                                                </Button>
                                                            </Col>
                                                            <Col xs={24} sm={24} md={24}>
                                                                <Form.List name={[field.name, 'list']}>
                                                                    {(list, { add, remove }) => {
                                                                        return (
                                                                            <>
                                                                                {list.map((field1, index1) => (
                                                                                    <Row xs={24} sm={24} md={24} key={field1.key}>
                                                                                        <Col xs={2} sm={2} md={2}>
                                                                                            <Button
                                                                                                type="danger"
                                                                                                title='Xóa loại giá này'
                                                                                                style={{ width: '100%' }}
                                                                                                onClick={() => remove(field1.name)}
                                                                                                icon={<MinusCircleOutlined />}
                                                                                            >
                                                                                            </Button>
                                                                                        </Col>
                                                                                        <Col xs={8} sm={8} md={8}>
                                                                                            <Form.Item
                                                                                                name={[index1, 'type_name']}
                                                                                                rules={[
                                                                                                    { required: true, message: 'Vui lòng nhập loại giá' }
                                                                                                    ,
                                                                                                    {
                                                                                                        type: 'string', max: 50, message: "Tên loại giá tối đa 50 ký tự !"
                                                                                                    }
                                                                                                ]}>
                                                                                                <Input placeholder="Nhập loại giá tiếng Việt" prefix={<img src='https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/vn.svg' style={{ width: 20, height: 20 }} />} />
                                                                                            </Form.Item>
                                                                                        </Col>
                                                                                        <Col xs={8} sm={8} md={8}>
                                                                                            <Form.Item
                                                                                                name={[index1, 'type_name_en']}
                                                                                                rules={[
                                                                                                    { required: true, message: 'Vui lòng nhập loại giá' }
                                                                                                    ,
                                                                                                    {
                                                                                                        type: 'string', max: 50, message: "Tên loại giá tối đa 50 ký tự !"
                                                                                                    }
                                                                                                ]}>
                                                                                                <Input placeholder="Nhập loại giá tiếng Anh" prefix={<img src='https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/gb.svg' style={{ width: 20, height: 20 }} />} />
                                                                                            </Form.Item>
                                                                                        </Col>
                                                                                        <Col xs={6} sm={6} md={6}>
                                                                                            <Form.Item
                                                                                                name={[index1, 'price']}
                                                                                                rules={[
                                                                                                    { required: true, message: 'Vui lòng nhập giá tiền' },
                                                                                                    {
                                                                                                        type: 'number', max: 100000000, message: "Giá tiền tối đa 100.000.000 !"
                                                                                                    }
                                                                                                ]}>
                                                                                                <InputNumber placeholder="Nhập giá tiền" min={0}
                                                                                                    formatter={value => `₫ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                                                                                    parser={value => value.replace('₫', '').replace(/\\s?|(,*)/g, '')}
                                                                                                    style={{ width: '100%' }} />
                                                                                            </Form.Item>
                                                                                        </Col>
                                                                                    </Row>
                                                                                ))}
                                                                                <Form.Item style={{ width: "100%" }}>
                                                                                    <Button
                                                                                        type="dashed"
                                                                                        onClick={() => add()}
                                                                                        style={{ width: "100%" }}
                                                                                    >
                                                                                        <PlusOutlined /> Thêm loại giá
                                                                                    </Button>
                                                                                </Form.Item>
                                                                                <Divider></Divider>
                                                                            </>
                                                                        );
                                                                    }}
                                                                </Form.List>

                                                            </Col>

                                                        </Row>
                                                    ))}
                                                <Row gutter={24}>
                                                    <Col xs={24} sm={24} md={24}>
                                                        <Form.Item>
                                                            <Button
                                                                type="dashed"
                                                                onClick={() => add()}
                                                                style={{ width: "100%" }}
                                                            >
                                                                <PlusOutlined /> Thêm bảng giá
                                                            </Button>
                                                        </Form.Item>
                                                    </Col>
                                                </Row>
                                            </>
                                        )
                                    }}
                                </Form.List>
                            </Col>
                        </Row>
                    </Tabs.TabPane>
                    <Tabs.TabPane forceRender={true} tab="Bảo hiểm y tế nhà nước" key="qtct" className="service-specialty" >
                        <Row gutter={[24]} align="middle">
                            <Col xs={24} sm={24} md={24}>
                                <Form.Item
                                    tooltip="Áp dụng bảo hiểm y tế nhà nước"
                                    name='is_government_insurance'
                                    valuePropName="checked"
                                >
                                    <Checkbox>Áp dụng bảo hiểm y tế nhà nước</Checkbox>
                                </Form.Item>
                                <Form.Item label="Ghi chú tiếng Việt" name="note_government_insurance"
                                    rules={[
                                        {
                                            type: 'string', max: 300, message: "Ghi chú về áp dụng loại bảo hiểm y tế nhà nước tối đa 300 ký tự !"
                                        }
                                    ]}>
                                    <TextArea showCount maxLength={300} style={{ width: '100%' }} rows={3} />
                                </Form.Item>
                                <Form.Item label="Ghi chú tiếng Anh" name="note_government_insurance_en"
                                    rules={[
                                        {
                                            type: 'string', max: 300, message: "Ghi chú về áp dụng loại bảo hiểm y tế nhà nước tối đa 300 ký tự !"
                                        }
                                    ]}>
                                    <TextArea showCount maxLength={300} style={{ width: '100%' }} rows={3} />
                                </Form.Item>
                            </Col>
                        </Row>
                    </Tabs.TabPane>
                    <Tabs.TabPane forceRender={true} tab="Bảo hiểm bảo lãnh trực tiếp" key="qtct1" className="service-specialty" >
                        <Row gutter={[24]} align="middle">
                            <Col xs={24} sm={24} md={24}>
                                <Form.Item
                                    tooltip="Áp dụng bảo hiểm bảo lãnh trực tiếp"
                                    name='is_direct_guarantee_insurance'
                                    valuePropName="checked"
                                >
                                    <Checkbox>Áp dụng bảo hiểm bảo lãnh trực tiếp</Checkbox>
                                </Form.Item>
                                <Form.Item label="Ghi chú tiếng Việt" name="note_direct_guarantee_insurance"
                                    rules={[
                                        {
                                            type: 'string', max: 300, message: "Ghi chú về áp dụng loại bảo hiểm bảo lãnh trực tiếp tối đa 300 ký tự !"
                                        }
                                    ]}>
                                    <TextArea showCount maxLength={300} style={{ width: '100%' }} rows={3} />
                                </Form.Item>
                                <Form.Item label="Ghi chú tiếng Anh" name="note_direct_guarantee_insurance_en"
                                    rules={[
                                        {
                                            type: 'string', max: 300, message: "Ghi chú về áp dụng loại bảo hiểm bảo lãnh trực tiếp tối đa 300 ký tự !"
                                        }
                                    ]}>
                                    <TextArea showCount maxLength={300} style={{ width: '100%' }} rows={3} />
                                </Form.Item>
                                <Divider>Danh sách công ty áp dụng</Divider>
                                <Form.List name="list_direct_guarantee_insurance" label="Danh sách công ty bảo lãnh được áp dụng">
                                    {(fields, { add, remove }) => {
                                        return (
                                            <>
                                                {
                                                    fields.map((field, index) => (
                                                        <Row gutter={24} key={field.key}>
                                                            <Col xs={22} sm={22} md={22}>
                                                                <Form.Item
                                                                    name={[index]}
                                                                    required tooltip="Tên công ty"
                                                                    rules={[
                                                                        {
                                                                            required: true, message: 'Vui lòng nhập tên công ty!'
                                                                        }, {
                                                                            type: 'string', max: 200, message: "Tên công ty tối đa 200 ký tự !"
                                                                        }
                                                                    ]}
                                                                >
                                                                    <Input placeholder="Nhập tên công ty" />
                                                                </Form.Item>
                                                            </Col>
                                                            <Col xs={2} sm={2} md={2}>
                                                                <Button
                                                                    type="link"
                                                                    danger
                                                                    style={{ width: '100%' }}
                                                                    onClick={() => remove(field.name)}
                                                                    title='Xóa công ty này'
                                                                    icon={<DeleteRowOutlined />}
                                                                >
                                                                </Button>
                                                            </Col>
                                                        </Row>
                                                    ))}
                                                <Row gutter={24}>
                                                    <Col xs={24} sm={24} md={24}>
                                                        <Form.Item>
                                                            <Button
                                                                type="dashed"
                                                                onClick={() => add()}
                                                                style={{ width: "100%" }}
                                                            >
                                                                <PlusOutlined /> Thêm công ty
                                                            </Button>
                                                        </Form.Item>
                                                    </Col>
                                                </Row>
                                            </>
                                        )
                                    }}
                                </Form.List>
                            </Col>
                        </Row>
                    </Tabs.TabPane>
                </Tabs>
            </Form>
        </Modal>
    )
}
export default ModalActionService;